import './font-awesome/font-awesome.config';

import schemaFormConfig from './schema-form/schema_form.config';

export default angular
    .module('BB.config', [])
    .config(schemaFormConfig)
    .name;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-config/main.module.js